import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({name: 'imagePipe'})
export class ImagePipe implements PipeTransform {

    transform(value: any, args?: any): string {
        if (args) {
            if (args[0] === 'resize') {
                if (args[1]) {
                    const width = args[1];
                    value = encodeURI(value);
                    return 'http://apiv3.plataformaasap.com.br/api/image/resize/' + width + '?image=' + value;
                }
            }
        }
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/app/@core/pipes/image.pipe.ts